import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { postGrupoCliente, postRelatorio } from '../modules/relatorios/apis/serviceRelatorio';
import { b64toBlob } from '../util/fieldMasks';
import { getFromSessionStorage } from './LocalStorage';
import { useModals } from './Modals';
import { postNotification, getNotification, putNotification, deleteNotification } from '../themes/api/serviceNotifications';
import moment from 'moment';
import { useEffectOnce } from 'react-use';
import { useAuth } from './Auth';

const RelatorioContext = createContext({} as PropsContextProvider);


type PropChildren = {
    children: ReactNode;
}

type PropsContextProvider = {
    setLoadingRelatorio: React.Dispatch<React.SetStateAction<loadingRelatorio>>,
    loadingRelatorio: loadingRelatorio,
    urls: urlsRelatorio,
    setUrls: React.Dispatch<React.SetStateAction<urlsRelatorio>>,
    notificacoes: any,
    setNotificacoes: React.Dispatch<React.SetStateAction<any>>,
    gerarRelatorio: (cod: string, parametros: string, history: any) => void,
    updateNotifi: (id: number, history: any) => void,
    deleteNotifi: (id: number, history: any) => void,
    buscarGruposClientes: (find: string, history: any) => Promise<any[]>,
    buscarNotifications: (id: number, history: any) => Promise<any>
}

interface urlsRelatorio {
    "RVPE620": string
    "RVPE621": string
    "RVPE571": string
    "RVPE558": string
    "RVPE461": string
    "RFNF520": string
    "SECE500": string
    "SECE504": string
    "PANT001": string
    "DSCF208": string
    "FRCR898": string
}

interface loadingRelatorio {
    "RVPE620": boolean
    "RVPE621": boolean
    "RVPE571": boolean
    "RVPE558": boolean
    "RVPE461": boolean
    "RFNF520": boolean
    "SECE500": boolean
    "SECE504": boolean
    "PANT001": boolean
    "DSCF208": boolean
    "FRCR898": boolean
}

export default function RelatorioProvider({ children }: PropChildren) {
    const [loadingRelatorio, setLoadingRelatorio] = useState<loadingRelatorio>({
        "RVPE620": false,
        "RVPE621": false,
        "RVPE571": false,
        "RVPE558": false,
        "RVPE461": false,
        "RFNF520": false,
        "SECE500": false,
        "SECE504": false,
        "PANT001": false,
        "DSCF208": false,
        "FRCR898": false
    });
    const [notificacoes, setNotificacoes] = useState<any[]>([]);
    const { mostrarInfoOK } = useModals();
    const [urls, setUrls] = useState<urlsRelatorio>({
        "RVPE620": "",
        "RVPE621": "",
        "RVPE571": "",
        "RVPE558": "",
        "RVPE461": "",
        "RFNF520": "",
        "SECE500": "",
        "SECE504": "",
        "PANT001": "",
        "DSCF208": "",
        "FRCR898": ""
    });
    const { socket, setSocket } = useAuth();

    function conectarSocket() {
        return new Promise<string>((resolve, reject) => {
            if (socket.connected) {
                //console.log("Conectado...");
                resolve(socket.id);
            } else {
                socket.connect().on("connect", () => {
                    //console.log("Acabou de conectar...");
                    if (socket.connected) {
                        setSocket(socket);
                        resolve(socket.id);
                    } else {
                        console.log("Erro ao conectar ao socket do servidor");
                        reject("Erro ao conectar ao socket do servidor");
                    }
                });
            }
        })
    }

    function updateNotifi(id: number, history: any) {
        let index = getIndexIdNotification(id);
        if (index >= 0) {
            let tempNotifi = [...notificacoes];
            tempNotifi[index].visualizado = true;
            setNotificacoes(tempNotifi);
        }
        putNotification(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
            .then(putResult => {
                //console.log(putResult);
            })
            .catch(err => {
                //console.log(err);
                if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                    redirectTo(history, '/login', { from: history.location.pathname });
                }
            })
    }

    function buscarNotifications(id: number, history: any) {
        return new Promise<any>((resolve, reject) => {
            getNotification(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    resolve(result instanceof Array ? result : [result]);
                })
                .catch(err => {
                    if (err.error !== undefined && (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido"))) {
                        redirectTo(history, '/login', { from: history.location.pathname });
                    }
                    reject(err);
                })
        })
    }

    function deleteNotifi(id: number, history: any) {
        let index = getIndexIdNotification(id);
        if (index >= 0) {
            let tempNotifi = [...notificacoes];
            tempNotifi.splice(index, 1);
            setNotificacoes(tempNotifi);
        }
        deleteNotification(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
            .then(putResult => {
                //console.log(putResult);
            })
            .catch(err => {
                if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                    redirectTo(history, '/login', { from: history.location.pathname });
                }
            })
    }

    function getIndexIdNotification(id: number) {
        for (let index = 0; index < notificacoes.length; index++) {
            const element = notificacoes[index];
            if (element.id === id) {
                return index;
            }
        }
        return -1
    }

    function gerarRelatorio(cod: string, parametros: string, history: any) {
        setLoadingRelatorio((prevState) => ({
            ...prevState,
            [cod]: true
        }));
        //console.log("conectado...");
        conectarSocket()
            .then(socketId => {
                //console.log("Iniciando geração...");
                //console.log(socket);

                //console.log("chamando a rota...");
                postRelatorio(cod, parametros, socketId, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                    .catch(err => {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        }
                    });
            })
            .catch(err => {
                setLoadingRelatorio((prevState) => ({
                    ...prevState,
                    [cod]: false
                }));
                console.log((err).toString());
                //mostrarInfoOK((err).toString());
            })
    }

    function buscarGruposClientes(find: string, history: any) {
        return new Promise<any[]>((resolve, reject) => {
            postGrupoCliente(find, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res instanceof Array ? res : [res])
                })
                .catch(err => {
                    if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                        redirectTo(history, '/login', { from: history.location.pathname });
                        reject("Sessão expirada, realize o login novamente.");
                    }
                    reject("Falha consultar grupos, contate o administrador.");
                })
        })
    }

    //Socket io area
    if (socket && !socket.hasListeners("report")) {
        socket.on("report", (res: any) => {
            //console.log(res);
            if (res.blob !== undefined) {
                if (res.blob !== "") {
                    let tempUrls = urls;
                    (tempUrls as any)[res.model] = window.URL.createObjectURL(b64toBlob(res.blob, "application/pdf", 512));
                    setUrls(tempUrls);
                }
                let objParams: any = {
                    "description": "",
                    "tipo": "",
                    "anexo": "",
                    "modelo": "",
                    "visualizado": false,
                    "data": "",
                    "representante": ""
                };
                let codRep = getFromSessionStorage("user_codrep") !== null ? getFromSessionStorage("user_codrep") : "";
                let dataNotif = moment(new Date(res.date)).format("DD/MM/YYYY");
                objParams["descricao"] = res.model + " - " + res.message.substring(0, 93);
                objParams["tipo"] = "report";
                objParams["anexo"] = res.blob;
                objParams["modelo"] = res.model;
                objParams["visualizado"] = false;
                objParams["data"] = dataNotif;
                objParams["representante"] = codRep;
                postNotification(JSON.parse(JSON.stringify(objParams)))
                    .then(postResult => {
                        getNotification("", getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                            .then(result => {
                                setNotificacoes(result instanceof Array ? result : [result]);
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(err => {
                        console.log(err);
                    })
                setLoadingRelatorio((prevState) => ({
                    ...prevState,
                    [res.model]: false
                }));

                //Mensagens de alerta!
                if (res.message.includes("Não houve informações")) {
                    setUrls({
                        "RVPE620": "",
                        "RVPE621": "",
                        "RVPE571": "",
                        "RVPE558": "",
                        "RVPE461": "",
                        "RFNF520": "",
                        "SECE500": "",
                        "SECE504": "",
                        "PANT001": "",
                        "DSCF208": "",
                        "FRCR898": ""
                    });
                    mostrarInfoOK("Não foi encontrado informações para os dados informados.");
                }
            }
            //socket.off("report");
        })
    }

    useEffectOnce(() => {
        getNotification("", getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
            .then(result => {
                setNotificacoes(result instanceof Array ? result : [result]);
            })
            .catch(error => {
                console.log(error)
            })
    })

    function redirectTo(history: any, pathname: string, state: { from: string }) {
        history.push({
            pathname: process.env.PUBLIC_URL + pathname,
            state: state
        })
    }

    return (
        <RelatorioContext.Provider
            value={{
                loadingRelatorio,
                urls,
                notificacoes,
                deleteNotifi,
                updateNotifi,
                setNotificacoes,
                setLoadingRelatorio,
                setUrls,
                gerarRelatorio,
                buscarGruposClientes,
                buscarNotifications
            }}>
            {children}
        </RelatorioContext.Provider>
    )
}

//A intenção de usar o hook para o contexto é facilitar a importação nos componentes,
//Somente o que estiver nesse hook poderá ser importado via hook, obviamente!
export function useRelatorios() {
    const context = useContext(RelatorioContext);
    if (!context) throw new Error("useRelatorio deve ser usado dentro de um RelatorioProvider");
    const {
        loadingRelatorio,
        urls,
        notificacoes,
        deleteNotifi,
        updateNotifi,
        setNotificacoes,
        setLoadingRelatorio,
        setUrls,
        gerarRelatorio,
        buscarGruposClientes,
        buscarNotifications
    } = context;
    return ({
        loadingRelatorio,
        urls,
        notificacoes,
        deleteNotifi,
        updateNotifi,
        setNotificacoes,
        setLoadingRelatorio,
        setUrls,
        gerarRelatorio,
        buscarGruposClientes,
        buscarNotifications
    });
}